import { __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React from 'react';
var DropdownMenuContext = /*#__PURE__*/React.createContext(null);

var reducer = function reducer(state, action) {
  var payload = action.payload,
      type = action.type;

  switch (type) {
    case 'SET_MENU_OPEN':
      return __assign(__assign({}, state), {
        menuOpen: payload
      });

    case 'SET_MENU_VISIBLE':
      return __assign(__assign({}, state), {
        menuVisible: payload
      });

    case 'INCREASE_SELECTED_ITEM_INDEX':
      return __assign(__assign({}, state), {
        selectedItemIndex: state.selectedItemIndex + 1
      });

    case 'DECREASE_SELECTED_ITEM_INDEX':
      return __assign(__assign({}, state), {
        selectedItemIndex: state.selectedItemIndex - 1
      });

    case 'SET_SELECTED_ITEM_INDEX':
      return __assign(__assign({}, state), {
        selectedItemIndex: payload
      });

    case 'SET_MENU_ITEMS':
      return __assign(__assign({}, state), {
        menuItems: payload
      });

    case 'SET_ACTIVE_DESCENDANT':
      return __assign(__assign({}, state), {
        activeDescendant: payload
      });

    case 'SET_PROPS':
      return __assign(__assign({}, state), {
        fcStyle: payload.fcStyle
      });

    case 'SET_BUTTON_REF':
      return __assign(__assign({}, state), {
        buttonEl: payload
      });

    default:
      return state;
  }
};

var DropdownMenuProvider = function DropdownMenuProvider(_a) {
  var children = _a.children,
      state = _a.state;

  var _b = React.useReducer(reducer, state),
      dropdownState = _b[0],
      dispatch = _b[1];

  return /*#__PURE__*/React.createElement(DropdownMenuContext.Provider, {
    value: {
      dropdownState: dropdownState,
      dispatch: dispatch
    }
  }, children);
};

var DropdownMenuConsumer = DropdownMenuContext.Consumer;
export { DropdownMenuConsumer, DropdownMenuContext, DropdownMenuProvider };